export default __webpack_public_path__ + "static/media/US.c43a153a.png";